/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".add-double-checkboxes[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{margin-top:.5rem;width:151px}@media (max-width:1024px){.showPassword[_ngcontent-%COMP%]{margin-bottom:-25px;position:relative}}\n/*# sourceMappingURL=ai-link-policy.component.css.map*/"];
export { styles as styles };
